<template>
  <div>
    <table v-if="treeData.measureName">
      <tr>
        <td
          :colspan="treeData.children ? treeData.children.length * 2 : 1"
          :class="{parentLevel: treeData.children && treeData.children.length>0, extend: treeData.children && treeData.children.length>0 && treeData.extend}"
        >
          <div :class="{node: true, hasMate: treeData.mate}">
            <div class="person" @click="$emit('click-node', treeData)">
              <div class="node-warp" style="cursor: n-resize;">
                <div class="node-title" type="0">
                  <label>{{treeData.measureName}}</label>
                </div>
                <div class="node-content">
                  <label>{{title}}</label>
                  <label>{{treeData.value?treeData.value:"-"}}</label>
                </div>
              </div>
            </div>
            <div class="person" v-if="treeData.mate" @click="$emit('click-node', treeData.mate)">
              <div class="node-warp" style="cursor: n-resize;">
                <div class="node-title" type="0">
                  <label>{{treeData.measureName}}</label>
                </div>
                <div class="node-content">
                  <label>{{title}}</label>
                  <label>{{treeData.value?treeData.value:"-"}}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="extend_handle"
            v-if="treeData.children && treeData.children.length>0"
            @click="toggleExtend(treeData)"
          ></div>
        </td>
      </tr>
      <tr v-if="treeData.children && treeData.extend">
        <td
          v-for="(children, index) in treeData.children"
          :key="index"
          colspan="2"
          class="childLevel"
        >
          <TreeChart :json="children" :title="title" @click-node="$emit('click-node', $event)" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "TreeChart",
  props: ["json", "title"],
  data() {
    return {
      treeData: {}
    };
  },
  watch: {
    json: {
      handler: function(Props) {
        let extendKey = function(jsonData) {
          jsonData.extend =
            jsonData.extend === void 0 ? true : !!jsonData.extend;
          if (Array.isArray(jsonData.children)) {
            jsonData.children.forEach(c => {
              extendKey(c);
            });
          }
          return jsonData;
        };
        if (Props) {
          this.treeData = extendKey(Props);
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleExtend: function(treeData) {
      treeData.extend = !treeData.extend;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
td {
  position: relative;
  vertical-align: top;
  padding: 0 0 50px 0;
  text-align: center;
}
.extend_handle {
  position: absolute;
  left: 50%;
  bottom: 30px;
  width: 10px;
  height: 10px;
  padding: 10px;
  transform: translate3d(-15px, 0, 0);
  cursor: pointer;
}
.extend_handle:before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 2px solid;
  border-color: #2b74a4 #2b74a4 transparent transparent;
  transform: rotateZ(135deg);
  transform-origin: 50% 50% 0;
  transition: transform ease 300ms;
}
.extend_handle:hover:before {
  border-color: #333 #333 transparent transparent;
}
.extend .extend_handle:before {
  transform: rotateZ(-45deg);
}
.extend::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 15px;
  height: 15px;
  border-left: 2px solid #2b74a4;
  transform: translate3d(-1px, 0, 0);
}
.childLevel::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 100%;
  height: 15px;
  border-left: 2px solid #2b74a4;
  transform: translate3d(-1px, 0, 0);
}
.childLevel::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: -15px;
  border-top: 2px solid #2b74a4;
}
.childLevel:first-child:before,
.childLevel:last-child:before {
  display: none;
}
.childLevel:first-child:after {
  left: 50%;
  height: 15px;
  border: 2px solid;
  border-color: #2b74a4 transparent transparent #2b74a4;
  border-radius: 6px 0 0 0;
  transform: translate3d(1px, 0, 0);
}
.childLevel:last-child:after {
  right: 50%;
  height: 15px;
  border: 2px solid;
  border-color: #2b74a4 #2b74a4 transparent transparent;
  border-radius: 0 6px 0 0;
  transform: translate3d(-1px, 0, 0);
}
.childLevel:first-child.childLevel:last-child::after {
  left: auto;
  border-radius: 0;
  border-color: transparent #2b74a4 transparent transparent;
  transform: translate3d(1px, 0, 0);
}
.node {
  position: relative;
  display: inline-block;
  width: 13em;
  box-sizing: border-box;
  text-align: center;
}
.node .person {
  position: relative;
  display: inline-block;
  z-index: 2;
  width: 6em;
  overflow: hidden;
}
.node.hasMate::after {
  content: "";
  position: absolute;
  left: 2em;
  right: 2em;
  top: 2em;
  border-top: 2px solid #2b74a4;
  z-index: 1;
}
.node.hasMate .person:last-child {
  margin-left: 1em;
}
.landscape {
  transform: translate(-100%, 0) rotate(-90deg);
  transform-origin: 100% 0;
}
.landscape .node {
  text-align: left;
  height: 8em;
  width: 8em;
}
.landscape .person {
  position: relative;
  transform: rotate(90deg);
  padding-left: 4.5em;
  height: 4em;
  top: 4em;
  left: -1em;
}
.landscape .hasMate {
  position: relative;
}
.landscape .hasMate .person {
  position: absolute;
}
.landscape .hasMate .person:first-child {
  left: auto;
  right: -4em;
}
.landscape .hasMate .person:last-child {
  left: -4em;
  margin-left: 0;
}
.node-warp {
  background-color: #ffffff;
  display: flex;
  flex-flow: column;
  width: 112px;
  z-index: 10;
  margin: 0 2px;
  border: 1px solid #2b74a4;
}

.drag-active {
  border-style: dotted !important;
}

.drop-hover {
  border-style: solid !important;
  border-color: #e05e00 !important;
}
.node-title {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 40px;
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
}
.node-title[type="0"] {
  background: #007947;
}
.node-title[type="1"] {
  background: #2b74a4;
}
.node-title[type="2"] {
  background: #9eb752;
}
a {
  display: block;
}

.jOrgChart .node {
  width: 160px;
  height: 80px;
  border-radius: 4px;
  margin: 0 8px;
}
.node-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  height: 100%;
  min-height: 40px;
  font-size: 12px;
}
</style>